import { useContext } from 'react';
import Slider from 'react-slick';
import { ThemeContext } from '@forma/forma-ui-kit';
import PageBlock from '@/components/PageBlock';

import styles from './reviews-2.module.css';

const ReviewItem = ({ review, author }) => {
  return (
    <div className={styles.review}>
      <div className={styles.reviewMessage} dangerouslySetInnerHTML={{ __html: review }} />
      {author && (
        <div className={styles.author}>
          {author.image && <img src={author.image} className={styles.authorImage} alt={author.name} />}
          <div>
            <div className={styles.authorName}>{author.name}</div>
            <div className={styles.authorPosition}>{author.position}</div>
          </div>
        </div>
      )}
    </div>
  );
};

const Reviews2 = ({ title, items }) => {
  const { viewport } = useContext(ThemeContext);
  const isPhone = viewport === 'phone';

  return (
    <PageBlock variant="white" className={styles.root} title={title}>
      <div className={styles.content}>
        {isPhone ? (
          <Slider className={styles.slider} arrows={false} infinite={false} dots={true}>
            {items.map((item, index) => (
              <ReviewItem {...item} key={index} />
            ))}
          </Slider>
        ) : (
          items.map((item, index) => (
            <ReviewItem {...item} key={index} />
          ))
        )}
      </div>
    </PageBlock>
  );
};

export default Reviews2;
